import { render, staticRenderFns } from "./BroadcastsOverlay.vue?vue&type=template&id=347c985e&scoped=true&"
import script from "./BroadcastsOverlay.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BroadcastsOverlay.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BroadcastsOverlay.vue?vue&type=style&index=0&id=347c985e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c985e",
  null
  
)

export default component.exports